import { render, staticRenderFns } from "./companyDialog.vue?vue&type=template&id=313275f7&scoped=true&"
import script from "./companyDialog.vue?vue&type=script&lang=js&"
export * from "./companyDialog.vue?vue&type=script&lang=js&"
import style0 from "./companyDialog.vue?vue&type=style&index=0&id=313275f7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313275f7",
  null
  
)

export default component.exports